// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"Post_pageLayout__gS2d5","innerContent":"Post_innerContent__FArbV","noPointerEvents":"Post_noPointerEvents__AKYAY","header":"Post_header__P_syM"};